import axios from "axios";
import { unauthorizedInterceptors } from "../../../core/utilities/functions";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

if (typeof unauthorizedInterceptors === "function") {
  unauthorizedInterceptors(api);
}

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  } else if (config.headers && "Authorization" in config.headers) {
    delete config.headers.Authorization;
  }
  return config;
});

export const dashboardAPI = {
  getOverview: async (
    brands = [],
    dateRange = "monthly",
    startDate = null,
    endDate = null
  ) => {
    const params = new URLSearchParams();
    if (brands.length > 0) params.append("brands", brands.join(","));
    params.append("date_range", dateRange);
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);
    const { data } = await api.get(
      `/accounting/dashboard/overview/?${params.toString()}`
    );
    return data;
  },

  // NOTE: matches your call order: (brands, filter, startDate, endDate, partners)
  getPaymentsDue: async (
    brands = [],
    filter = "weekly",
    startDate = null,
    endDate = null,
    partners = []
  ) => {
    const params = { filter };
    if (brands?.length) params.brands = brands.join(",");
    if (partners?.length) params.partners = partners.join(","); // send partners to backend
    if (filter === "custom" && startDate && endDate) {
      params.start_date = startDate;
      params.end_date = endDate;
    }
    const { data } = await api.get("/accounting/dashboard/payments-due/", {
      params,
    });
    return data;
  },

  getSummary: async (brands = []) => {
    const params = {};
    if (brands?.length) params.brands = brands.join(",");
    const { data } = await api.get("/accounting/api/dashboard-summary/", {
      params,
    });
    return data;
  },

  getBrands: async () => {
    const { data } = await api.get("/settings/api/brands/filter-by-client/");
    return data;
  },
};

// ✅ pass dateRange/start/end through
export const getDashboardData = (
  brands = [],
  dateRange = "monthly",
  startDate = null,
  endDate = null
) => dashboardAPI.getOverview(brands, dateRange, startDate, endDate);

// ✅ matches the component usage: (brands, filter, startDate, endDate, partners)
export const getPaymentsDueData = (
  brands = [],
  filter = "weekly",
  startDate = null,
  endDate = null,
  partners = []
) => dashboardAPI.getPaymentsDue(brands, filter, startDate, endDate, partners);

export default dashboardAPI;
